export var menuData = [
  {
    value: 0,
    display: 'Women',
    link: '/c/women',
    manual_cm_sp: 'Womens-_-header-_-nav',
  },
  {
    value: 1,
    display: 'Juniors',
    link: '/c/juniors',
    manual_cm_sp: 'Juniors-_-header-_-nav',
  },
  {
    value: 4,
    display: 'Shoes',
    link: '/c/shoes',
    manual_cm_sp: 'Shoes-_-header-_-nav',
  },
  {
    value: 5,
    display: 'Handbags',
    link: '/c/handbags',
    manual_cm_sp: 'handbags-_-header-_-nav',
  },
  {
    value: 6,
    display: 'Accessories',
    link: '/c/accessories',
    manual_cm_sp: 'accessories-_-header-_-nav',
  },
  {
    value: 7,
    display: 'Lingerie',
    link: '/c/lingerie',
    manual_cm_sp: 'lingerie-_-header-_-nav',
  },
  {
    value: 9,
    display: 'Beauty',
    link: '/c/beauty',
    manual_cm_sp: 'Beauty-_-header-_-nav',
  },
  {
    value: 2,
    display: 'Men',
    link: '/c/men',
    manual_cm_sp: 'Mens-_-header-_-nav',
  },
  {
    value: 3,
    display: 'Kids',
    link: '/c/kids',
    manual_cm_sp: 'Kids-_-header-_-nav',
  },
  {
    value: 8,
    display: 'Home',
    link: '/c/home',
    manual_cm_sp: 'Home-_-header-_-nav',
  },
  {
    value: 10,
    display: "Dillard's Exclusive",
    link: '/c/exclusive-brands',
    manual_cm_sp: 'dillards+exclusive-_-header-_-nav',
  },
  {
    value: 11,
    display: 'Just For You',
    link: '/c/just-for-you',
    manual_cm_sp: 'just+for+you-_-header-_-nav',
  },
];
